// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createUserModalStyles } from "@plumberssupply/Overrides/Widgets/UserList/CreateUserModal";
import { xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

createUserModalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        &&&& {
            margin-top: 9px;
        }
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            row-gap: 20px;
        }
    `,
};
createUserModalStyles.submitButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
createUserModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

createUserModalStyles.settingsHeadingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

createUserModalStyles.emailGridItem = {
    width: 12,
    css: css`
        position: relative;
    `,
};

createUserModalStyles.emailTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            position: absolute;
            left: 45px;
            top: 2px;
        `,
    },
    iconProps: {
        size: 13,
    },
};

createUserModalStyles.userNameVisibleGridItem =
    createUserModalStyles.firstNameGridItem =
    createUserModalStyles.lastNameGridItem =
    createUserModalStyles.roleGridItem =
    createUserModalStyles.warehousesGridItem =
    createUserModalStyles.formGridItem =
        { width: [12, 6, 6, 6, 6] };

createUserModalStyles.radioGroupGridItem = createUserModalStyles.paymentPortalGridItem = { width: 12 };

createUserModalStyles.warehouseSelect = {
    labelProps: {
        css: css`
            line-height: 16px;
            min-height: auto;
        `,
    },
};
